var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[
    'button is-rounded ' + _vm.size + ' ' + _vm.type,
    { 'is-loading': _vm.ajaxloading[_vm.loadingKey] } ],attrs:{"native-type":"submit"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }